/* [BD feat] Tom 2026-09-16 — shine each gold button once when it enters the viewport */
(function () {
  function init() {
    var buttons = document.querySelectorAll('.bd-gold-shine:not(.is-shining), .bd-gold-shine-text:not(.is-shining)');
    if (!buttons.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-shining');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    buttons.forEach(function (button) { observer.observe(button); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
/* [/BD feat] */
